import {UIUtilsEjsVariables} from '../../../../shared/scripts/UIUtilsEjsVariables'
import {UIWGameFeedView} from './UIWGameFeedView'
import {UIGameManager} from 'code/client/shared/scripts/ui_game/UIGameManager'

export class UIDGameFeedView extends UIWGameFeedView {
    constructor(uiGameManager: UIGameManager) {
        super(uiGameManager)
        this.setChatStyles()
    }

    setChatVisibility() {
        this.isChatEnabled = !UIUtilsEjsVariables.isUserOnDiscordMobile

        if(this.gameChat == undefined) return
        this.isChatEnabled ? this.gameChat.showChat() : this.gameChat.hideChat()
    }

    private setChatStyles() {
        this.gameChat.mainBlock.classList.add('discord')
        this.gameChat.formElement.classList.add('discord')
        this.gameChat.buttonElement.classList.add('discord')
    }
}
